import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    let token = localStorage.getItem('auth')
    if (!token) {
      next({
        path: '/login',
      })
    } else {
      next()
    }
  } else {
    let token = localStorage.getItem('auth')
    if(!token) {

      next() // make sure to always call next()!
    } else {
      next({
        path: '/',
      })
    }
  }
})

createApp(App).use(router).mount('#app')
